<script lang="ts">
import UpsellScreenBox from '@/V2/components/upsell/UpsellScreenBox.vue';
import UpsellScreenMain from '@/V2/components/upsell/UpsellScreenMain.vue';
import { InscribeEventsLogger, INSCRIBE_EVENTS } from '@/events-logger';
export default {
  name: 'UpsellScreenCredit',
  components: {
    UpsellScreenBox,
    UpsellScreenMain,
  },
  methods: {
    onPrimaryButtonClicked() {
      InscribeEventsLogger.logEvent(INSCRIBE_EVENTS.UPSELL_BUTTON_CLICKED, {
        button: 'credit-schedule-call',
      });
      window.open('https://calendar.app.google/2veu2MNaCo9XH7qo6', '_blank');
    },
    onSecondaryButtonClicked() {
      InscribeEventsLogger.logEvent(INSCRIBE_EVENTS.UPSELL_BUTTON_CLICKED, {
        button: 'credit-learn-more',
      });
      window.open(
        ' https://www.inscribe.ai/resources/demo-center/cashflow-analysis-demo',
        '_blank',
      );
    },
  },
};
</script>

<template>
  <div class="upsell-screen-credit d-flex flex-column i-gap-8">
    <!-- main -->
    <upsell-screen-main
      icon="large-graph-2"
      title="Credit Insights"
      description="Add credit insights to your toolkit to automate income verification, assess creditworthiness, and reduce risk with faster, more inclusive lending decisions."
      primary-button-label="Schedule a Call"
      secondary-button-label="Learn More"
      @primary-button-clicked="onPrimaryButtonClicked"
      @secondary-button-clicked="onSecondaryButtonClicked"
    ></upsell-screen-main>

    <!-- boxes -->
    <div class="boxes-container d-flex flex-row i-gap-8">
      <upsell-screen-box
        icon="medium-money-coins"
        title="Income Verification"
        description="Quickly verify income from bank statements and open banking data."
      />

      <upsell-screen-box
        icon="medium-money-atm-card-1"
        title="Loan & Repayment Analysis"
        description="Track loan disbursements, repayment patterns, and identify potential credit risks."
      />

      <upsell-screen-box
        icon="medium-money-graph-bar"
        title="Cashflow Assessment"
        description="Get a clear picture of net income, credits, debits, and spending habits over time."
      />

      <upsell-screen-box
        icon="medium-setting-gauge-dashboard-1"
        title="Transaction Categorization"
        description="Classify transactions into income and expense types, and adjust as necessary."
      />

      <upsell-screen-box
        icon="medium-money-bank"
        title="Open Banking Support"
        description="Run credit analysis on data from Plaid, MX, and bank documents—seamlessly."
      />

      <upsell-screen-box
        icon="medium-alert-alarm-bell-1"
        title="Risky Transaction Detection"
        description="Spot gambling, NSF, and ATM withdrawal patterns that signal elevated credit risk."
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.upsell-screen-credit {
  max-width: 1200px;
  margin: 0 auto;

  .boxes-container {
    max-width: 100%;
    flex-wrap: wrap;
  }
}
</style>
